module.exports = __webpack_public_path__ + "img/1to1newlogo.1570e7ac.png";